import Vue from 'vue';
import { hasAccess, getPermissions } from './permissions';
import OrganizationSettingsApi from '~/api/organization_settings';

const permissions = getPermissions();

const HasAccess = {
    install(Vue, options) {
        Vue.prototype.$getPermissions = function() {
            return permissions;
        };

        Vue.prototype.$hasAccess = function(permission) {
            return permissions.includes(permission);
        };

        Vue.prototype.$hasAccessAny = function(permissionArr) {
            return permissionArr.some(item => {
                return permissions.includes(item);
            });
        };

        Vue.prototype.$getOrgSetting = async function(setting) {
            let rsp = await OrganizationSettingsApi.getSetting({name: setting});
            return rsp[setting];
        };

        Vue.directive('has-access', {
            bind(el, binding, vnode) {
                if (!hasAccess(binding.value)) {
                    el.innerHTML = '';
                }
            }
        });
    }
};

export default HasAccess;
